import { supabase } from "@/integrations/supabase/client";

const AVATARS_BUCKET = "avatars";

function getSafeFileExtension(fileName: string, mimeType: string) {
  const extension = fileName.split(".").pop()?.toLowerCase().replace(/[^a-z0-9]/g, "");

  if (extension) {
    return extension;
  }

  const mimeExtension = mimeType.split("/").pop()?.toLowerCase().replace(/[^a-z0-9]/g, "");
  return mimeExtension || "png";
}

export async function uploadCandidateAvatar(file: File) {
  if (!file.type.startsWith("image/")) {
    throw new Error("Por favor, selecione apenas arquivos de imagem.");
  }

  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError) {
    throw userError;
  }

  if (!user) {
    throw new Error("Usuário não autenticado.");
  }

  const fileExt = getSafeFileExtension(file.name, file.type);
  const filePath = `${user.id}/${crypto.randomUUID()}.${fileExt}`;

  console.log("Iniciando upload do avatar:", filePath);

  const { error: uploadError } = await supabase.storage
    .from(AVATARS_BUCKET)
    .upload(filePath, file, {
      cacheControl: "3600",
      contentType: file.type,
      upsert: true,
    });

  if (uploadError) {
    console.error("Erro no upload do avatar:", uploadError);
    throw uploadError;
  }

  const {
    data: { publicUrl },
  } = supabase.storage.from(AVATARS_BUCKET).getPublicUrl(filePath);

  console.log("Avatar enviado com sucesso:", filePath);

  return { filePath, publicUrl };
}